module.exports = __webpack_public_path__ + "static/media/LC.32212a92.png";